import { Question } from './question.model';

export class FaqGroup {
    constructor(public categoryId: number, public categoryName: string, public displayOrder: number) {}

    public questions: Question[];
}
